import React from 'react';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { Breadcrumbs } from 'components/Breadcrumbs/Breadcrumbs';
import { useHistory } from 'react-router-dom';
import { Nullable } from 'global';
import { BroadcastEditorModes } from 'modules/broadcasts/types';
import { getBroadcastEditorBreadcrumbLabel } from 'modules/broadcasts/lib';

interface Props {
  mode: BroadcastEditorModes;
  broadcastTitle: Nullable<string>;
}

export const HeaderCard = ({ mode, broadcastTitle }: Props) => {
  const { push } = useHistory();

  const breadcrumbLabel = getBroadcastEditorBreadcrumbLabel(mode);
  const cardTitle = broadcastTitle || 'Create Broadcast';

  return (
    <CardContainer
      overTitleActionBtn={
        <Breadcrumbs
          currentValue="createEditViewBroadcast"
          config={[
            { label: 'Dealer Management', value: 'dealers', onClick: () => push('/dealers') },
            { label: breadcrumbLabel, value: 'createEditViewBroadcast', onClick: () => {} },
          ]}
        />
      }
      title={cardTitle}
    ></CardContainer>
  );
};
